module.exports = __webpack_public_path__ + "static/media/chicken-curry.1c7e96ac.jpg";